<template>
  <v-container fill-height>
    <v-layout column  align-center justify-center>
      <img @dragstart.prevent width="400px" :src="require('@/assets/平安成电logo(立体效果1)jpg.jpg')" alt="SMACO" class="mb-5">
      <div class="display-1 pt-4 grey--text">电子科技大学平安成电智慧通行管理系统</div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>

</style>
